import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

class Parallax {
  constructor(dom) {
    this.dom = dom;
    this.init();
  }

  init() {
    gsap.from(this.dom, {
      scrollTrigger: {
        trigger: this.dom,
        start: 'top bottom', // Start when the top of the trigger hits the bottom of the viewport
        end: 'bottom top', // End when the bottom of the trigger hits the top of the viewport
        scrub: true,
        onUpdate: self => {
          // Calculate the progress from 1 to -1
          const progress = 1 - self.progress * 2; // self.progress goes from 0 to 1, so 1 - 2*progress maps it from 1 to -1
          // Update the CSS variable on the document's root element
          this.dom.style.setProperty('--item-scroll-progress', progress);
        },
        ease: 'none',
      },
    });
  }
}

export default Parallax;
